module.exports = __webpack_public_path__ + "files/0a664f5aabb1374a190bb550b234c47d.png";